module.exports = __webpack_public_path__ + "img/architecture.37042737.jpg";